import React, {useState} from 'react'
import './IndividualPersonView.css'

import Person from './Person';
import SearchInput from './SearchInput';

// DB
import { db } from '../utils/User/include/Authorize'
import { useStateValue } from '../utils/Provider/StateProvider';


function IndividualPersonView() {
    const [{ user, myrelative }] = useStateValue();

    const [isFilterApplied, setFilterApplied] = useState(false);
    const [filterList, setFilterList] = useState()

    const filteringResult = (e, char) => {
        setFilterApplied(true)
        setFilterList(e)

        if(char.length === 0){
            setFilterApplied(false)
        }
    }

  return (
    <div>

        <div className='custom_individualPerson_view_search_input_div'>
            <SearchInput placeholder='Search your relative' width='100%' filterFrom={myrelative} onFilter={(e, char) => filteringResult(e, char) } />
        </div>

        {isFilterApplied && myrelative && filterList.length === 0 && <p className="no_match_caution_msg">No match found 😔</p>}


        <div className='individualPerson_container_view'>
            {myrelative && !isFilterApplied ?
                    (
                        Object.keys(myrelative).map(i => (
                            myrelative[i].person_data.map((person, index) => (
                                <div className='individualPerson_wrap_flexibleDiv'>
                                    <Person details={person} uuid={myrelative[i].uuid} familyId={i} personId={index}/>
                                </div>
                            ))
                        ))
                    )

                :

                (isFilterApplied ? null : <p className='no_relative_individualPerson_view'>No record found</p>)
            }


            {isFilterApplied && myrelative && 

                filterList.map(filter => (
                    Object.keys(myrelative).map(i => (
                        myrelative[i].person_data.map((person, index) => (

                            (filter === person.name ? 
                                <div className='individualPerson_wrap_flexibleDiv_fixedWidth'>
                                    <Person details={person} uuid={myrelative[i].uuid} familyId={i} personId={index}/>
                                </div>
                                :
                                // <p>oops</p>
                                null
                            )
                        ))
                    ))
                ))
            }
        </div>
    </div>
  )
}

export default IndividualPersonView